export default __webpack_public_path__ + "static/logo_100x100-3315e037eb1fe785b7b7ff8ecde04e76.png";